import { Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import WorkorderTypesAdminActions from "../../../views/super-admin/views/compinfos/tabs/interventions-types/WorkorderTypesAdminActions";
import { getInvoicingMethodLabel } from "../invoicing-method/invoicingMethodLabel";

function resolveServiceLabel(
  type: EasyTech.WorkorderType,
  index: number,
  catalog: EasyTech.Service[]
): string {
  const entry = type.services?.[index];
  if (entry?.serviceLabel) {
    return entry.serviceLabel;
  }

  const serviceId = entry?.serviceId ?? (index === 0 ? type.serviceId : undefined);
  if (serviceId) {
    const match = catalog.find((service) => service.id === serviceId);
    if (match?.label) {
      return match.label;
    }
  }

  if (index === 0 && type.serviceLabel) {
    return type.serviceLabel;
  }

  return "-";
}

/**
* WorkorderTypeListItem: Display type list item
* @param type - Type data
* @param services - List of available services
* @param onClick - On click event
* @param onChange - On change event
* @param isLast - Is last item 
*/
export default function WorkorderTypeListItem({
  type,
  services = [],
  onClick,
  onChange,
  isLast = false
}: {
  type: EasyTech.WorkorderType,
  services?: EasyTech.Service[],
  onClick?: () => void,
  onChange: () => void,
  isLast?: boolean
}) {
  const { t } = useTranslation();
  const service1Label = resolveServiceLabel(type, 0, services);
  const service2Label = resolveServiceLabel(type, 1, services);
  const service1InvoicingMethod = type.services?.[0]?.invoicingMethod;
  const service2InvoicingMethod = type.services?.[1]?.invoicingMethod;

  return (
    <tr className={`page-list-item ${isLast && "last"}`} onClick={() => onClick && onClick()}>
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{type.label}</Typography>
        </div>
      </td>

      <td>
        <div className="flex flex-col gap-1">
          <Typography className="font-medium text-sm">
            {service1Label}
          </Typography>
          {service1InvoicingMethod && (
            <span className="text-xs text-gray-500 italic">
              {getInvoicingMethodLabel(service1InvoicingMethod, t)}
            </span>
          )}
        </div>
      </td>

      <td>
        <div className="flex flex-col gap-1">
          <Typography className="font-medium text-sm">
            {service2Label}
          </Typography>
          {service2InvoicingMethod && (
            <span className="text-xs text-gray-500 italic">
              {getInvoicingMethodLabel(service2InvoicingMethod, t)}
            </span>
          )}
        </div>
      </td>

      <td>
        <div className="flex gap-2 items-center">
          <Typography>{type.enabled ? "Yes" : "No"}</Typography>
        </div>
      </td>
      <td><WorkorderTypesAdminActions type={type} onChange={onChange} /></td>
    </tr>
  );
}